import React, { useEffect, useState } from 'react';
import api from '../../api/axios';
import { getToken } from '../../utils/auth';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

const BloqueadosAdmin = () => {
  const [numeros, setNumeros] = useState([]);
  const [busqueda, setBusqueda] = useState('');
  const [nuevoNumero, setNuevoNumero] = useState({ telefono: '', nombre: '' });

  const cargarNumeros = async () => {
    const token = getToken();
    try {
      const res = await api.get('/numeros-bloqueados', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setNumeros(res.data.numeros || []);
    } catch (err) {
      console.error('❌ Error al cargar números bloqueados:', err);
      toast.error('Error al cargar los números bloqueados');
    }
  };

  useEffect(() => {
    cargarNumeros();
  }, []);

  const handleChange = (e, id) => {
    const { name, value } = e.target;
    setNumeros(prev =>
      prev.map(numero => (numero.id === id ? { ...numero, [name]: value } : numero))
    );
  };

  const handlePhoneChange = (value, id) => {
    setNumeros(prev =>
      prev.map(numero => (numero.id === id ? { ...numero, telefono: value } : numero))
    );
  };

  const guardarCambios = async (id, telefono, nombre) => {
    const token = getToken();
    try {
      await api.put(`/numeros-bloqueados/${id}`, { telefono, nombre }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Número actualizado correctamente');
      cargarNumeros();
    } catch (err) {
      console.error('❌ Error al actualizar número:', err);
      toast.error('Error al actualizar número');
    }
  };

  const eliminarNumero = async (id) => {
    const confirmar = window.confirm('¿Seguro que deseas eliminar este número bloqueado?');
    if (!confirmar) return;

    const token = getToken();
    try {
      await api.delete(`/numeros-bloqueados/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Número eliminado');
      cargarNumeros();
    } catch (err) {
      console.error('❌ Error al eliminar número:', err);
      toast.error('Error al eliminar número');
    }
  };

  const crearNumero = async () => {
    const token = getToken();
    if (!nuevoNumero.telefono) {
      toast.warning('Introduce al menos el número de teléfono');
      return;
    }
    try {
      await api.post('/numeros-bloqueados', nuevoNumero, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Número bloqueado creado');
      setNuevoNumero({ telefono: '', nombre: '' });
      cargarNumeros();
    } catch (err) {
      console.error('❌ Error al crear número:', err);
      toast.error('Error al crear número');
    }
  };

  const numerosFiltrados = numeros.filter(n =>
    n.telefono.includes(busqueda) || (n.nombre && n.nombre.toLowerCase().includes(busqueda.toLowerCase()))
  );

  return (
    <main className="site-width">
      <div className="texto-dashboard">
        <h1>Números bloqueados</h1>
        <p>Gestiona los teléfonos que no pueden iniciar sesión, registrarse o reservar.</p>
      </div>
      <div className="buscador-bloqueados">
        <input
          type="text"
          placeholder="Buscar por teléfono o nombre..."
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />
      </div>


      <div className="overflow-tabla">

      <div className="tabla-bloqueados tabla-clientes">
        <div className="tabla-header">
          <div>Nombre</div>
          <div>Teléfono</div>
          <div>Acciones</div>
        </div>

        {numerosFiltrados.map(numero => (
          <div key={numero.id} className="tabla-row">
            <div>
              <input
                type="text"
                name="nombre"
                value={numero.nombre || ''}
                onChange={(e) => handleChange(e, numero.id)}
              />
            </div>
            <div>
              <PhoneInput
                country={'es'}
                value={numero.telefono}
                onChange={(value) => handlePhoneChange(value, numero.id)}
              />
            </div>
            <div className="acciones-clientes">
              <button className="boton-guardar" onClick={() => guardarCambios(numero.id, numero.telefono, numero.nombre)}>
                <img src="/images/confirmar.svg" alt="Guardar" />
              </button>
              <button className="boton-eliminar" onClick={() => eliminarNumero(numero.id)}>
                <img src="/images/cancelar.svg" alt="Eliminar" />
              </button>
            </div>
          </div>
        ))}

        {/* Crear nuevo número */}
        <div className="tabla-row tabla-crear">
          <div>
            <input
              type="text"
              placeholder="Nombre (opcional)"
              value={nuevoNumero.nombre}
              onChange={(e) => setNuevoNumero({ ...nuevoNumero, nombre: e.target.value })}
            />
          </div>
          <div>
            <PhoneInput
              country={'es'}
              value={nuevoNumero.telefono}
              onChange={(value) => setNuevoNumero({ ...nuevoNumero, telefono: value })}
            />
          </div>
          <div>
            <button className="boton-guardar-bloqueado" onClick={crearNumero}>Añadir</button>
          </div>
        </div>
      </div>

      </div>

      <ToastContainer position="bottom-right" autoClose={3000} />
    </main>
  );
};

export default BloqueadosAdmin;
